import React from "react";

const HowToSetUp: React.FC = () => (
	<section id="how-to-set-up" className="live-setup-steps">
        <h2>How to Setup</h2>
        <p>Once you have everything you need, set up is simple.</p>
        <div className="step-container">
          <div className="step">
            <h4><span>1</span> Open Your TacBoard Live Photo Stream</h4>
            <div className="img-container">
              <div className="feature-icon how-to">
                <img src="img/live-setup-login-btn.jpg" />
                <p>Click "log in" at tacboard.com</p>
              </div>
              <div className="feature-icon how-to">
                <img src="img/live-setup-log-in-nl.jpg" />
                <p>Log in</p>
              </div>
              <div className="feature-icon how-to">
                <img src="img/live-setup-select-gallery-nl.jpg" />
                <p>Click on your gallery's name</p>
              </div>
              <div className="feature-icon how-to">
                <img src="img/live-setup-live-btn.jpg" />
                <p>Click the "Live" button</p>
              </div>
            </div>
          </div>
          <div className="step">
            <h4><span>2</span> Hook Laptop to TV / Projector</h4>
            <div className="img-container">
              <div className="feature-icon how-to">
                <img src="img/live-setup-HDMI-cable.jpg" />
                <p>Get your HDMI cable.</p>
              </div>
              <div className="feature-icon how-to">
                <img src="img/live-setup-HDMI-to-computer.jpg" />
                <p>Connect one end of the HDMI cable to the laptop.</p>
              </div>
              <div className="feature-icon how-to">
                <img src="img/live-setup-HDMI-to-tv.jpg" />
                <p>
                  Connect the other end of the HDMI cable to the TV or
                  projector.
                </p>
              </div>
              <div className="feature-icon how-to">
                <img src="img/live-setup-HDMI-tv-input.jpg" />
                <p>
                  Turn on the tv/projector and make sure the correct input is
                  selected.
                </p>
              </div>
            </div>
          </div>
          <div className="step">
            <h4>Now you're all set up and ready to go.</h4>
            <p>
              Your friends, family and guests can now begin texting photos to
              your gallery's phone number and those photos will instantly start
              scrolling on your Live Photo Stream. This means more fun for your
              guests and more photos from your event!
            </p>
          </div>
        </div>
      </section>
);

export default HowToSetUp;
